import React from 'react';
import { useContext, useEffect, useState } from 'react';
import { useRouter } from "next/router";

import {
    Button,
    Grid,
    Typography
} from '@mui/material';

export default function DashboardTicket(props) {
    const { ticket, isStaff, userId } = props;

    const router = useRouter();

    const handleEdit = () => {
        router.push(`/events/annual-conference/ticket/${ticket.ticketId}`);
    };

    return (
        <div className='flex flex-1 flex-col md:flex-row justify-between'>
            <div className={(ticket.isRegistered ? 'text-secondary-500' : 'text-red-400')}>
                <div className={'text-xl p-3 font-bold '}>
                    Ticket ID : {ticket.ticketId}
                </div>
                <div className={'text-xl p-3 font-bold '}>
                    Purchased By : <span className="text-xl text-gray-600 font-normal"> {ticket?.purchasedBy}</span>
                </div>
                <div className='flex p-3 flex-wrap space-x-3'>
                    {ticket.isAssigned && (
                        <>
                            <div className='text-xl font-bold'>
                                Assigned to:
                            </div>
                            <div className='text-xl text-gray-600 flex-wrap break-all'>
                                <Typography className='text-xl'>
                                    {ticket.firstName}  {ticket.lastName} - {ticket.email}
                                </Typography>
                            </div>
                        </>
                    )}
                    {!ticket.isAssigned && (
                        <div className='text-xl font-bold'>
                            Unassigned
                        </div>
                    )}
                </div>
                <div className='flex p-3 text-xl font-bold'>
                    {ticket.isRegistered ? 'Has Completed Registration' : 'NOT Yet Registered for the Conference'}
                </div>
            </div>
            {!userId && !isStaff && <div>
                <div className='flex p-5 h-full items-center'>
                    <div className='flex flex-1 justify-end'>
                        <Button
                            variant="contained"
                            className={'w-fit ' + (ticket.isRegistered ? 'bg-secondary-500 hover:bg-secondary-500' : 'bg-red-400 hover:bg-red-400')}
                            onClick={handleEdit}
                        >
                            {ticket.isRegistered ? 'Edit' : 'Register'}
                        </Button>
                    </div>
                </div>
            </div>}
        </div>
    )
}
